import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../../modules/shared/services/auth.service";
import {AlertService} from "../../../../modules/shared/services/alert.service";

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss'],
  providers: [AuthService]
})
export class ChangePasswordModalComponent implements OnInit {

  form: UntypedFormGroup;
  loading = false;
  constructor(
      public modal: NgbActiveModal,
      private authService: AuthService,
      private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = new UntypedFormGroup({
      actual_password: new UntypedFormControl(null, Validators.required),
      password: new UntypedFormControl(null, Validators.required),
      password_confirmation: new UntypedFormControl(null, Validators.required),
    })
  }

  save() {
    if (!this.form.valid) {
      return;
    }

    this.loading = true;
    this.authService.changePassword(this.form.value).subscribe((result) => {
      this.loading = false;
      this.alertService.showSuccess('Hasło zmienione poprawnie');
      this.modal.dismiss(true);
    }, () => {
      this.loading = false;
    })
  }
}
